import { formatDate, parseServerUtcMs } from "@/lib/utils";
import CustomTooltip from "./custom-tooltip";
import React from "react";

const DateTimeDisplay = React.forwardRef<
  HTMLSpanElement,
  {
    utcDate: string;
    side?: "top" | "right" | "bottom" | "left";
  }
>(({ utcDate, side }, ref) => {
  const ms = parseServerUtcMs(utcDate);
  const tooltipText = Number.isFinite(ms)
    ? new Date(ms).toLocaleString()
    : "";
  return (
    <CustomTooltip text={tooltipText} side={side}>
      <span ref={ref} className="text-sm text-muted cursor-default">
        {formatDate(utcDate)}
      </span>
    </CustomTooltip>
  );
});

DateTimeDisplay.displayName = "DateTimeDisplay";

export default DateTimeDisplay;
